import { render, staticRenderFns } from "./Reopen.vue?vue&type=template&id=34956ecc&lang=pug"
import script from "./Reopen.vue?vue&type=script&lang=js"
export * from "./Reopen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports